import { Component, OnInit } from '@angular/core';
import { WordSearchService } from '../services/word-search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  constructor(public wordSearchService: WordSearchService, public navigationService: NavigationService) {

  }

  ngOnInit() {}

}
